<template>
  <div class="form-group">
        <textarea rows="3"
        :type="type"
        class="form-control"
        @input="onChanged"
        :class="getClasses(size, valid)"
        :name="name"
        :id="id"
        :value="value"
        :placeholder="placeholder"
        :isRequired="isRequired"
        :readonly="readonly"
      />
  </div>
</template>

<script>
export default {
  name: "argon-input",
  props: {
    size: {
      type: String,
      default: "default",
    },
    valid: {
      type: Boolean,
      default: false,
    },
    icon: String,
    iconDir: String,
    name: String,
    id: String,
    value: String,
    placeholder: String,
    type: String,
    isRequired: Boolean,
    readonly: Boolean,
    maxLength: Number
  },
  methods: {
    getClasses: (size, valid) => {
      let sizeValue, isValidValue;

      sizeValue = size ? `form-control-${size}` : null;

      isValidValue = valid ? `${valid}` : "invalid";

      return `${sizeValue} ${isValidValue}`;
    },
    getIcon: (icon) => (icon ? icon : null),
    hasIcon: (icon) => (icon ? "input-group" : null),
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    function onChanged(e) {
      if(props.maxLength && e.currentTarget.value.length > props.maxLength){
        e.currentTarget.value = e.currentTarget.value.substr(0, props.maxLength)
        return;
      }
      emit("update:value", e.currentTarget.value);
    }

    return {
      onChanged,
    };
  },
};
</script>
